import {Button} from "antd";
import {updateCheckoutIgnore} from "../../api/updateCheckoutIgnore";
import useUserContext from "../../hooks/useUserContext";
import {ToastSkin} from "../../context/ToastContext";
import useToast from "../../hooks/useToast";

interface IgnoredCheckoutTooltipContentProps {
    checkoutId: number;
    reFetch?: () => void;
}

export const IgnoredCheckoutTooltipContent = ({ checkoutId, reFetch }: IgnoredCheckoutTooltipContentProps) => {
    const { selectedDomain } = useUserContext();
    const { showToast } = useToast();
    const onClick = async () => {
        if(selectedDomain) {
            const response = await updateCheckoutIgnore(selectedDomain, checkoutId, false);
            if(response?.data?.errorMessage || !response?.data) {
                showToast({ skin: ToastSkin.error, text: 'Failed to update ignored status for the checkout you requested' });
            } else {
                showToast({ skin: ToastSkin.approval, text: 'Checkout status was updated' });
                reFetch && reFetch();
            }
        }
    }

    return (
        <div>
            <div>This checkout was skipped because the customer did not provide the required consent, or it was deliberately excluded from the recovery process.</div>
            <Button type="default" size="small" className="tooltip-button" onClick={onClick}>Allow Recovery</Button>
        </div>
    )
}